export const defaultAdultAge = 20;
